export default __webpack_public_path__ + "static/assets/7c71210a204459473c95a40052db8664.png";